import { render, staticRenderFns } from "./ErafLogo.vue?vue&type=template&id=4b7d3ee1&"
import script from "./ErafLogo.vue?vue&type=script&lang=js&"
export * from "./ErafLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports